'use strict'

// Settings configured here will be merged into the final config object.
export default {
  language: 'hu'
}



// WEBPACK FOOTER //
// ./src/config/base.js